var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';
import { CardProvider } from './card-context';
import { cardStyle, decorStyle, headstoneStaticStyle } from './styles';
function CardInternal(_a, ref) {
    var as = _a.as, children = _a.children, _b = _a.disableHoverEffect, disableHoverEffect = _b === void 0 ? false : _b, headstone = _a.headstone, _c = _a.highlightPlacement, highlightPlacement = _c === void 0 ? 'left' : _c, _d = _a.highlightVariant, highlightVariant = _d === void 0 ? 'green' : _d, _e = _a.inverted, inverted = _e === void 0 ? false : _e, _f = _a.size, size = _f === void 0 ? 'medium' : _f, _g = _a.variant, variant = _g === void 0 ? 'regular' : _g, restProps = __rest(_a, ["as", "children", "disableHoverEffect", "headstone", "highlightPlacement", "highlightVariant", "inverted", "size", "variant"]);
    var Element = as !== null && as !== void 0 ? as : 'section';
    var _h = useFocusRing(), focusProps = _h.focusProps, isFocusVisible = _h.isFocusVisible;
    var typedRestProps = restProps;
    var hasHeadstone = headstone != null;
    return (_jsx(CardProvider, __assign({ size: size }, { children: _jsxs(Element, __assign({ css: cardStyle({
                disableHoverEffect: disableHoverEffect,
                hasHeadstone: hasHeadstone,
                inverted: inverted,
                isFocusVisible: isFocusVisible,
            }), ref: ref }, mergeProps(focusProps, typedRestProps), { children: [hasHeadstone && _jsx("div", __assign({ css: headstoneStaticStyle }, { children: headstone })), variant === 'highlight' && (_jsx("div", { css: decorStyle({ highlightPlacement: highlightPlacement, highlightVariant: highlightVariant }) })), children] })) })));
}
export default CardInternal;
